import Rest from 'services/data/rest';

export default class MfaDevice extends Rest {
  static path = 'mfadevice';
  static defaultQuery = {
    sort: 'name',
    load: ['team']
  };
}

